import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { postNotifySubscriberContactMethodsOptOut } from "../../../queries/notify";
import { buildNotifyInfiniteSubscriberContactMethodsQueryKey } from "./useInfiniteNotifySubscriberContactMethods";
import { buildNotifySubscriberContactMethodQueryKey } from "./useNotifySubscriberContactMethod";
import { buildNotifySubscriberContactMethodsQueryKey } from "./useNotifySubscriberContactMethodsForLoggedInUser";

interface IUseNotifySubscriberContactMethodOptOut {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export function useNotifySubscriberContactMethodOptOut({ onSuccess }: IUseNotifySubscriberContactMethodOptOut = {}) {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();

  const [optOutSubscriberContactMethodMutation, { isLoading: isOptOutSubscriberContactMethodLoading }] = useMutation(
    postNotifySubscriberContactMethodsOptOut(networkHeaders),
    {
      onSuccess: async (_, { subscriberContactMethodIds }) => {
        await Promise.all(
          subscriberContactMethodIds.map((subscriberContactMethodId) => {
            return queryCache.invalidateQueries(
              buildNotifySubscriberContactMethodQueryKey({ id: subscriberContactMethodId }),
            );
          }),
        );
        await queryCache.invalidateQueries(buildNotifySubscriberContactMethodsQueryKey());
        await queryCache.invalidateQueries(buildNotifyInfiniteSubscriberContactMethodsQueryKey());
        if (onSuccess) {
          onSuccess();
        }
      },
    },
  );

  const optOutSubscriberContactMethod = async ({
    subscriberContactMethodIds,
  }: {
    subscriberContactMethodIds: number[];
  }) => {
    return await optOutSubscriberContactMethodMutation({
      subscriberContactMethodIds,
    });
  };

  return { optOutSubscriberContactMethod, isOptOutSubscriberContactMethodLoading };
}
